import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const PRIMARY = "#6A46E5";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper: {
      borderRadius: 16,
      padding: "8px 8px 24px",
      margin: 16,
      maxWidth: 400,
      width: "100%",
      position: "relative",
      overflow: "visible",
    },
    closeButton: {
      position: "absolute",
      top: 8,
      right: 8,
      color: "#9E9E9E",
      padding: 8,
    },
    content: {
      padding: "8px 24px 0 24px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    image: {
      width: 250,
      height: "auto",
      marginBottom: 12,
      objectFit: "contain",
    },
    title: {
      fontSize: 22,
      fontWeight: 700,
      color: "#1A1A1A",
      marginTop: 8,
      lineHeight: 1.3,
      marginBlockEnd: 0,
    },
    message: {
      fontSize: 15,
      fontWeight: 400,
      lineHeight: 1.5,
      textAlign: "center",
    },
    actions: {
      display: "flex",
      gap: 12,
      width: "100%",
      padding: "0 20px",
      boxSizing: "border-box",
      marginTop: 16,
    },
    actionButton: {
      flex: 1,
      height: 44,
      borderRadius: "22px !important",
      textTransform: "none",
      fontSize: 16,
      fontWeight: 600,
    },
    closeBtn: {
      border: "1.5px solid #E0E0E0 !important",
      color: "#4D4E5D !important",
      backgroundColor: "#FFFFFF !important",
    },
    viewBtn: {
      backgroundColor: `${PRIMARY} !important`,
      color: "#FFFFFF !important",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#5A3AD4 !important",
        boxShadow: "none",
      },
    },
  })
);

export default useStyles;
